<template>
  <div v-if="this.leaves != null">
    {{ this.leaves.leavesAvailed }} / {{ this.leaves.monthlyMaximumLeaves }}
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { calculateCarryOver } from '@/services/carryOverService';

export default {
  name: "userRequiredLeaves",
  props: ['user', 'from', 'to', 'showSum', 'carryOver', 'index', 'showCarryOverFromPreviousYear'],
  data: function () {
    return {
      leaves: {}
    }
  },
  created: function () {
  },
  methods: {
  },
  mounted() {
    console.log("Mounted userRequiredLeaves, index " + this.index);

    //Load users
    axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "leaves/CalculateMonthlyLeaveSummary?userid=" + this.user.id + "&from=" + this.from.format('yyyy-MM-DD') + "&to=" + this.to.format('yyyy-MM-DD') }).then(result => {
      //   console.log(result.data);
      this.leaves = result.data;
      var carryoverCalculated = this.leaves.monthlyMaximumLeaves - this.leaves.leavesAvailed;

      this.$emit('carryOverCalculated', this.index, carryoverCalculated);

    }, error => {
      console.error(error);
      this.dataLoaded = false;
      if (error.response.status == 401) {
        this.$router.push("/");
      }
    });

    // get previous year hours, pass them to carryover
    if (this.index == 1) {
      var toNow = moment(this.from).startOf("year").format("yyyy-MM-DD");
      calculateCarryOver(this.user, toNow)
      .then(totalLeavesDifferencePrevYear => {
        this.$emit('carryOverCalculated', 1, totalLeavesDifferencePrevYear, true);
      })
      .catch(error => {
        console.error(error);
      });
    }
  }
};
</script>
